import { IncomingMessage, ServerResponse } from 'http';

const setCanonicalLink = (req: IncomingMessage, res: ServerResponse) => {
    res.setHeader('Link', `<${process.env.NEXT_PUBLIC_BASE_URL}${(req.url ?? '').split('?')[0]}>; rel="canonical"`);
};

export default setCanonicalLink;
